import { useEffect } from 'react';

import { setClerkTokenGetter } from '@/api';
import { useAuth } from '@clerk/react';

export const ClerkAxiosSetup: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getToken } = useAuth();

  useEffect(() => {
    setClerkTokenGetter(() => getToken({ template: 'default' }));
  }, [getToken]);

  return <>{children}</>;
};
